<mat-toolbar class="nav-bar">
  <div class="nav-bar-content">
    <img [src]="logoSrc()" class="logo logo-paisagem" alt="Logo" />
    @if (user()) {
    <div class="user-block">
      <button matButton [matMenuTriggerFor]="menu" class="button-menu-user">
        <div class="profile-dropdown">
          <div class="user-info">
            <p title="{{ user()?.name }}">{{ getFirstAndLastName(user()?.name!) }}</p>
            @if (user()?.role) {
            <span>{{ user()?.role?.name }}</span>
            }
          </div>
          <div>
            <div class="container-img">
              <img
                [src]="user()?.avatar || 'assets/images/avatar_null.jpg'"
                alt="{{ user()?.name }} Avatar"
                (error)="onAvatarError($event)"
              />
            </div>
            <mat-icon class="icon-size">keyboard_arrow_down</mat-icon>
          </div>
        </div>
      </button>
      <mat-menu xPosition="before" #menu="matMenu">
        <button mat-menu-item routerLink="/main/perfil">
          <mat-icon>person_outline</mat-icon>
          Perfil
        </button>
        @if (user()?.role_id !== adminRoleId) {
        <!-- <button mat-menu-item>
          <mat-icon>download</mat-icon>
          Baixar logs
        </button> -->
        }
        <!-- <button mat-menu-item>
          <mat-icon>north_east</mat-icon>
          Suporte
        </button> -->
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          Sair
        </button>
      </mat-menu>
      @if (emblemSrc()) {
      <img [src]="emblemSrc()" class="logo logo-emblem" alt="Brasão" data-testid="header-emblem" />
      }
    </div>
    } @else {
    <p>Loading user information...</p>
    }
  </div>
</mat-toolbar>
